import {FC, useCallback} from "react";
import {useTranslation} from "react-i18next";
import {useDispatch, useSelector} from "react-redux";
import {
	getIsTeamEmpty,
	getIsTeamFull,
	getPickedPlayersCounter,
	getPlayersCounter,
	getTeamsCount,
} from "modules/selectors";
import {ConnextraType, createConnextraScriptTag} from "modules/utils";
import {openConfirmPicksModal, saveUserTeamRequest} from "modules/actions";
import {MAX_TEAM_COUNT} from "modules/constants";
import {Button, Item, Value, Wrapper} from "./common";

export const AllStarTeamGameBar: FC = () => {
	const {t} = useTranslation();
	const dispatch = useDispatch();
	const pickedPlayersCounter = useSelector(getPickedPlayersCounter);
	const playersCounter = useSelector(getPlayersCounter);
	const isTeamEmpty = useSelector(getIsTeamEmpty);
	const isTeamFull = useSelector(getIsTeamFull);
	const teamsCount = useSelector(getTeamsCount);

	const handleSave = useCallback(() => {
		if (!isTeamFull) {
			dispatch(openConfirmPicksModal());
			return;
		}

		dispatch(saveUserTeamRequest());
		createConnextraScriptTag(ConnextraType.PICKS_CONFIRM, null);
	}, [dispatch, isTeamFull]);

	return (
		<Wrapper>
			<Item>
				<Value>
					{pickedPlayersCounter}/{playersCounter}
				</Value>
				<div>{t("page.picks.game_bar.selected")}</div>
			</Item>
			<Item>
				<Value>
					{teamsCount}/{MAX_TEAM_COUNT}
				</Value>
				<div>{t("page.picks.game_bar.votes")}</div>
			</Item>
			<Item>
				<Button onClick={handleSave} disabled={isTeamEmpty}>
					{t("page.picks.game_bar.vote_now")}
				</Button>
			</Item>
		</Wrapper>
	);
};
